import { Component } from 'react';
import styles from './DeprecatedStylesContainer.scss';

export default class DeprecatedStylesContainer extends Component {
    render(){
        return(
            <div className={styles.overflowHidden} data-cy="DeprecatedStylesContainer">
                {this.props.children}
            </div>
        );
    }   
}